<template>
    <b-row>
        <b-col cols="12">
            <label for="reporter">Placa:</label>
            <app-form-text-input
                v-model="plate"
                :input-classes="{ 'plate-input': true }"
                @input="$v.plate.$touch()"
                :has-error="$v.plate.$error"
                required
            ></app-form-text-input>
        </b-col>
        <!-- ------------------------ datos del vehiculo ----------------------------->

        <b-col cols="12" v-if="notExistPlate">
            <b-form-checkbox
                value="1"
                v-model="internal"
                name="check-button"
                switch
                >Es interno el vehículo?</b-form-checkbox
            >
        </b-col>
        <br />
        <br />
        <b-col cols="12" md="6" v-if="notExistPlate">
            <label for="structure">Tipo de vehículo:</label>
            <app-form-select-input
                :options="vehicleTypes"
                v-model="vehicleType"
            ></app-form-select-input>
        </b-col>
        <b-col cols="12" md="6" v-if="isInternal">
            <label for="structure">Estructura:</label>
            <app-form-select-input
                :options="structures"
                v-model="vehicleStructure"
            ></app-form-select-input>
        </b-col>

        <b-col cols="12" class="py-2" v-if="notExistPlate">
            <label for="title">Marca:</label>
            <b-form-input
                type="text"
                size="sm"
                id="brand"
                v-model="brand"
            ></b-form-input>
        </b-col>
        <b-col cols="12" class="py-2" v-if="notExistPlate">
            <label for="title">Referencia:</label>
            <b-form-input
                type="text"
                size="sm"
                id="reference"
                v-model="reference"
            ></b-form-input>
        </b-col>
        <b-col cols="12" class="py-2" v-if="notExistPlate">
            <b-btn variant="primary" @click="saveVehicle">Registrar</b-btn>
            <b-btn @click="cancel">Cancelar</b-btn>
        </b-col>
        <!-- ------------------------ fin datos vehiculo ----------------------------->
        <div v-if="info" class="w-100">
            <b-col cols="12" v-if="!accessPoint">
                <app-form-select-input
                    label="Puesto"
                    :options="serviceSpots"
                    v-model="serviceSpotId"
                    @change="$v.serviceSpotId.$touch()"
                    :has-error="$v.serviceSpotId.$error"
                    required
                ></app-form-select-input>
            </b-col>
            <b-col cols="12">
                <label for="reporter">Propietario:</label>
                <app-form-text-input v-model="data.owner"></app-form-text-input>
            </b-col>
            <b-col cols="12" md="6" class="py-2">
                <b-form-checkbox
                    unchecked-value="0"
                    value="1"
                    v-model="data.hit"
                    name="check-button"
                    switch
                    >Golpes</b-form-checkbox
                >
            </b-col>
            <b-col cols="12" md="6" class="py-2">
                <b-form-checkbox
                    unchecked-value="0"
                    value="1"
                    v-model="data.scratch"
                    name="check-button"
                    switch
                    >Rayones</b-form-checkbox
                >
            </b-col>
            <b-col cols="12" md="6" class="py-2">
                <b-form-checkbox
                    unchecked-value="0"
                    value="1"
                    v-model="data.radio"
                    name="check-button"
                    switch
                    >Radio</b-form-checkbox
                >
            </b-col>
            <b-col cols="12" md="6" class="py-2">
                <b-form-checkbox
                    unchecked-value="0"
                    value="1"
                    v-model="data.antenna"
                    name="check-button"
                    switch
                    >Antena</b-form-checkbox
                >
            </b-col>
            <b-col cols="12" md="6" class="py-2">
                <b-form-checkbox
                    unchecked-value="0"
                    value="1"
                    v-model="data.mirror"
                    name="check-button"
                    switch
                    >Espejos</b-form-checkbox
                >
            </b-col>
            <b-col cols="12" md="6" class="py-2">
                <b-form-checkbox
                    unchecked-value="0"
                    value="1"
                    v-model="data.wheel"
                    name="check-button"
                    switch
                    >Llantas</b-form-checkbox
                >
            </b-col>
            <b-col cols="12" md="6" class="py-2">
                <b-form-checkbox
                    unchecked-value="0"
                    value="1"
                    v-model="data.bezel"
                    name="check-button"
                    switch
                    >Biseles</b-form-checkbox
                >
            </b-col>
            <b-col cols="12" md="6" class="py-2">
                <b-form-checkbox
                    unchecked-value="0"
                    value="1"
                    v-model="data.accesories"
                    name="check-button"
                    switch
                    >Accesorios</b-form-checkbox
                >
            </b-col>
            <b-col cols="12" class="py-2">
                <label for="reporter">Observaciones:</label>
                <b-form-textarea v-model="data.observation"></b-form-textarea>
            </b-col>
            <b-col cols="12" class="py-2">
                <b-form-file
                    placeholder="Agregar imágenes"
                    v-model="files"
                    multiple
                    accept="image/*"
                ></b-form-file>
            </b-col>
        </div>
    </b-row>
</template>
<script>
import { required, requiredIf } from 'vuelidate/lib/validators'
export default {
    props: {
        clientId: {
            type: [String, Number],
            default: 0,
        },
    },
    data: () => ({
        plate: '',
        data: {
            owner: '',
            hit: '0',
            scratch: '0',
            radio: '0',
            antenna: '0',
            mirror: '0',
            wheel: '0',
            bezel: '0',
            accesories: '0',
            observation: '',
        },
        vehicleType: '',
        vehicleStructure: '',
        brand: '',
        reference: '',
        info: true,
        notExistPlate: false,
        isInternal: false,
        internal: false,
        structures: [],
        vehicleTypes: [],
        files: [],
        serviceSpotId: '',
        serviceSpots: [],
    }),
    validations: {
        plate: { required },
        serviceSpotId: {
            required: requiredIf(function() {
                return !this.accessPoint
            }),
        },
    },
    watch: {
        internal(val) {
            if (val) {
                this.isInternal = true
            } else {
                this.isInternal = false
            }
        },
    },
    computed: {
        theClientId() {
            return !!this.clientId ? this.clientId : this.client.id
        },
        theServiceSpotId() {
            return !!this.accessPoint ? this.accessPoint.id : this.serviceSpotId
        },
    },
    methods: {
        async saveVehicleState() {
            this.$v.$touch()

            if (this.$v.$invalid)
                return toastr.error('Debe diligenciar los campos adecuadamente')

            const formData = new FormData()
            formData.append('plate', this.plate)
            formData.append('structureId', this.theServiceSpotId)
            formData.append('clientId', this.theClientId)

            _.forIn(this.data, (value, key) => {
                formData.append(`vehicleState[${key}]`, value)
            })

            if (this.files.length) {
                this.files.map(item => formData.append('files[]', item))
            }
            const { data } = await repo.post('vehicle-states', formData)

            if (data.vehic) {
                toastr.info(data.msg)
                this.notExistPlate = true
                this.info = false
                this.$emit('disableBtn')
                return
            }
            if (data.status) {
                toastr.success(data.msg)
                this.clearData()
                this.$emit('saveVehicleState')
            }
        },
        async loadStructures() {
            if (!this.client) return
            const { data } = await repo.get('structures', {
                client: this.theClientId,
            })
            this.structures = data
        },
        async loadVehicleTypes() {
            const { data } = await repo.get('vehicle-types')
            this.vehicleTypes = data
        },
        async saveVehicle() {
            if (this.data.plate === '' || this.vehicleType === '') {
                toastr.error('Ingrese toda la información')
                return
            }

            const { data } = await repo.post('vehicles', {
                structureId: this.vehicleStructure,
                clientId: this.theClientId,
                vehicleTypeId: this.vehicleType,
                plate: this.plate,
                brand: this.brand,
                reference: this.reference,
                internal: this.internal,
            })

            if (data.status) {
                toastr.success(data.msg)
                this.notExistPlate = false
                this.info = true
                this.isInternal = false
                this.$emit('enableBtn')
                this.$nextTick(() => (this.serviceSpotId = this.serviceSpotId))
            } else {
                toastr.error(data.msg)
            }
        },
        async loadServiceSpots() {
            if (!!this.accessPoint || !this.client) return

            const { data } = await repo.get('service-spots', {
                client: this.theClientId,
            })
            this.serviceSpots = data
        },
        clearData() {
            this.plate = ''
            this.data.owner = ''
            this.data.hit = '0'
            this.data.scratch = '0'
            this.data.radio = '0'
            this.data.antenna = '0'
            this.data.mirror = '0'
            this.data.wheel = '0'
            this.data.bezel = '0'
            this.data.accesories = '0'
            this.data.observation = ''
            this.internal = false
            this.brand = ''
            this.reference = ''
            this.notExistPlate = false
            this.info = true
            this.serviceSpotId = ''
            this.$emit('enableBtn')
        },
        cancel() {
            this.notExistPlate = false
            this.info = true
            this.clearData()
            this.$emit('enableBtn')
        },
    },
    mounted() {
        this.loadStructures()
        this.loadVehicleTypes()
        this.$bus.$on('clearData', this.clearData)

        this.loadServiceSpots()
    },
}
</script>
